/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./minecate.vue?vue&type=template&id=6b2bb56c&scoped=true"
import script from "./minecate.vue?vue&type=script&lang=js"
export * from "./minecate.vue?vue&type=script&lang=js"
import style0 from "./minecate.vue?vue&type=style&index=0&id=6b2bb56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2bb56c",
  null
  
)

export default component.exports